import React, {useEffect} from "react";
import {Typography} from "@material-ui/core";
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import TemplateComponent from "../../component/template/TemplateComponent";
import DynamicTitle from "../../component/DynamicTitle";
import phone from "../../assets/img/phone.png"
import {DeviceScreen, Path} from "../../utils/Constant";
import {NavTo} from "../../utils/AppManager";
import {AcnColorTheme} from "../../assets/css/AcnColorTheme";
import {fontUnit, heightUnit, padGinUnit, widthUnit} from "../../utils/DeviceManager";

export function DecisionScreen() {

    useEffect(() => {
        document.title = "สมัครใช้งาน\u200E\u200E";
    }, [])

    const [screen] = useSelector((state: RootState) => [
        state.deviceReducer.screenView
    ]);

    const onConnect = () => {
        NavTo(Path.account)
    }

    const onNotConnect = () => {
        NavTo(Path.nationalId)
    }

    const successWidget = () => {
        return (
            // <div className="center-screen" style={{overflow: "auto", paddingTop: padGinUnit(32)}}>
            <div  style={{position: 'fixed', overflow: "hidden", marginRight: '20px'}}>
                {/* <div style={{maxWidth: widthUnit(425), height:heightUnit( window.innerHeight * 0.8)}}> */}
                <div style={{height: heightUnit( window.innerHeight * 0.97), overflowY: "auto", paddingTop: padGinUnit(32)}}>
                    <div style={{
                            paddingLeft: screen === DeviceScreen.DESKTOP ? '' : padGinUnit(24), 
                            paddingRight: screen === DeviceScreen.DESKTOP ? '': padGinUnit(24)
                    }}>
                        <DynamicTitle title={"เชื่อมต่อไชโยConnect"} align={"left"} isFull={true} size={fontUnit(30)}/>
                        <Typography align={"left"}
                                    style={{fontFamily: "Thonburi", fontSize: fontUnit(18), color: AcnColorTheme.black, fontWeight: "normal", justifyContent: "left"}}>
                            คุณอนุญาตให้ไชโย Connect เชื่อมต่อกับบัญชีไชโยของคุณหรือไม่?
                        </Typography>
                    </div>
                    <img
                        style={{
                            width: screen === DeviceScreen.DESKTOP ? widthUnit(411) : window.innerWidth,
                            // height: screen === DeviceScreen.MOBILE ? widthUnit(window.innerWidth*0.73) : heightUnit(411),
                            marginTop: padGinUnit(24)
                        }}
                        src={phone} alt={"logo"}/>
                    {
                        window.innerHeight <= 500? <div style={{height: heightUnit(200)}}/> : <div/>
                    }
                </div>
            </div>
        )
    }

    return (
        <TemplateComponent content={successWidget()}
                           background={AcnColorTheme.primary}
                           onNext={onConnect}
                           isCanNext={true}
                           nextText={"เชื่อมต่อ"}
                           optionNext={onNotConnect}
                           optionText={"ยังไม่เชื่อมต่อ"}
                           noPadding
        />
    );
}